module.exports = __webpack_public_path__ + "img/id.9a7548fd.svg";